import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from '../services/user-data.service';
import { OnboardingService } from '../services/onboarding.service';

export const loggedInGuard: CanActivateFn = async (route, state) => {
  const userData = inject(UserDataService);
  const router = inject(Router);

  // Load user data
  if (userData.getUser() === null) {
    await userData.loadUserData(false);
  }

  if (userData.getUser() !== null) {
    router.navigate(['/dashboard']);
  }

  return true;
};
